export function getRandomNormal(mean, stdDev, min=0, max=100) {
    let value = Math.random() * stdDev + mean;
    if (value < min) {
        value = min;
    } else if (value > max) {
        value = max;
    }
    return value;
}